import { combineReducers } from "redux";
import { navigationReducer } from "./navigation";
import { publicBadgeReducer } from "./publicBadge";
import { badgesReducer } from "./badges";
import { loaderReducer } from "./loader";
import { loginReducer } from "./login";
import { sessionReducer } from "./session";
import { notificationReducer } from "./notification";

const rootState = {
  navigationReducer,
  publicBadgeReducer,
  badgesReducer,
  loaderReducer,
  loginReducer,
  sessionReducer,
  notificationReducer,
};

const rootReducer = combineReducers(rootState);

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
